import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {AbstractControl, FormControl, FormGroup, ValidatorFn, Validators} from "@angular/forms";
import {getErrorMessage} from '../../utils/validators-messages.utils';
import {DatiPersonaFisicaModel, LocalitaModel, NazioneModel, VerificaPfResponseDTO} from "../../models/estremi-persona-fisica.model";
import {ibanValidator} from "ngx-iban";
import {BonificoSepaModel} from "../../models/bonifico-sepa.model";

@Component({
	selector: "lib-bonifico-sepa",
	templateUrl: "./bonifico-sepa.component.html",
	styleUrls: ["./bonifico-sepa.component.scss"],
})
export class BonificoSepaComponent implements OnInit {

	@Input()
	bonificoSepa: BonificoSepaModel;

	@Input()
	nazioni: NazioneModel[];

	@Input()
	province: LocalitaModel[];

	@Input()
	isPersonaFisicaSepaValid: boolean;

	@Input()
	sepaFormPath: string;

	@Input()
	estremiPFSepaFormPath: string;

	@Input()
	viewSessoPF: boolean = false;

	@Input()
	validateAndGetResidenza: VerificaPfResponseDTO;

	@Output()
	validateSepaPersonaFisicaEmitter = new EventEmitter<void>();

	@Output()
	resetEstremiPersonaFisicaSepaFormEmitter = new EventEmitter<void>();

	@Output()
	bonificoSepaReady = new EventEmitter<{ bonifico: BonificoSepaModel, isValid: boolean }>();

	@Output()
	personaFisicaEmitter = new EventEmitter<{ persona: DatiPersonaFisicaModel, isValid: boolean }>();

	sepaForm: FormGroup;

	getErrorMessage = getErrorMessage;

	ibanValidators = [Validators.required, this.sepaCountriesValidator(), ibanValidator(), this.noSpacesValidator()];

	sepaCountries = [{"name":"Austria","code":"AT","iban":"AT493200056563289974"},{"name":"Belgium","code":"BE","iban":"BE65561689528896"},{"name":"Bulgaria","code":"BG","iban":"BG92TTBB94006559266188"},{"name":"Cyprus","code":"CY","iban":"CY52665561416772369457864437"},{"name":"Croatia","code":"HR","iban":"HR5523400098663266246"},{"name":"Denmark","code":"DK","iban":"DK2550515918328528"},{"name":"Estonia","code":"EE","iban":"EE591286653867491786"},{"name":"Finland","code":"FI","iban":"FI8479486911788598"},{"name":"France","code":"FR","iban":"FR8514508000707239488738J21"},{"name":"Germany","code":"DE","iban":"DE14500105174185484177"},{"name":"Greece","code":"GR","iban":"GR9201494491588141549531799"},{"name":"Ireland","code":"IE","iban":"IE29AIBK93115212345678"},{"name":"Italy","code":"IT","iban":"IT77R0300203280648419668253"},{"name":"Latvia","code":"LV","iban":"LV80BANK0000435195001"},{"name":"Lithuania","code":"LT","iban":"LT275168179993645428"},{"name":"Luxembourg","code":"LU","iban":"LU350106814331716425"},{"name":"Malta","code":"MT","iban":"MT54WLCI12377529685589454747835"},{"name":"Netherlands","code":"NL","iban":"NL13INGB6755037397"},{"name":"Poland","code":"PL","iban":"PL06109024023962236263666664"},{"name":"Portugal","code":"PT","iban":"PT26003506516995234369482"},{"name":"Czech Republic","code":"CZ","iban":"CZ1350515343291243261222"},{"name":"Romania","code":"RO","iban":"RO64RZBR2335521926768262"},{"name":"Slovakia","code":"SK","iban":"SK6053419589142643828262"},{"name":"Slovenia","code":"SI","iban":"SI97975426678332786"},{"name":"Spain","code":"ES","iban":"ES7231904977492569944158"},{"name":"Sweden","code":"SE","iban":"SE4949996195749755572136"},{"name":"Hungary","code":"HU","iban":"HU42117730161111101800000000"},{"name":"Norway","code":"NO","iban":"NO9386011117947"},{"name":"Liechtenstein","code":"LI","iban":"LI7008800683146527484"},{"name":"Iceland","code":"IS","iban":"IS140159260076545510730339"},{"name":"Switzerland","code":"CH","iban":"CH4789144623328263139"},{"name":"United Kingdom","code":"GB","iban":"GB09BARC20040416289669"},{"name":"Monaco","code":"MC","iban":"MC2112739000407179846124F08"},{"name":"Andorra","code":"AD","iban":"AD5127638574262995775744"},{"name":"San Marino","code":"SM","iban":"SM86U0322509800000000270100"},{"name":"Holy See (Vatican City State)","code":"VA","iban":"VA59001123000012345678"}];

	delegato: DatiPersonaFisicaModel;

	isDelegatoValid: boolean;

	constructor() {
		// this.initSepaForm();
	}

	ngOnInit(): void {
		this.initSepaForm();

		this.sepaForm.valueChanges.subscribe(() => {
      // if (this.sepaForm.valid) {
        const bonificoSepa: BonificoSepaModel = {
					iban: this.sepaForm.get('iban').value,
					delegato: this.sepaForm.get('existsDelegatoRiscossione').value,
					delegatoRiscossione: this.sepaForm.get('existsDelegatoRiscossione').value ? this.delegato : null,
				};

				const isFormValid = this.sepaForm.valid;
				const isFormDelegatoValid = this.sepaForm.get('existsDelegatoRiscossione').value === true ? this.isDelegatoValid : true;
        const isValid = isFormValid && isFormDelegatoValid;

        this.bonificoSepaReady.emit({ bonifico: bonificoSepa, isValid });
       //}
    });
	}

	initSepaForm(): void {
		this.sepaForm = new FormGroup({
			existsDelegatoRiscossione: new FormControl(this.bonificoSepa != null ? this.bonificoSepa.delegato : false, [Validators.required]),
			iban: new FormControl(this.bonificoSepa?.iban, this.ibanValidators),
		});
	}

	onValidateSepaPersonaFisica(): void {
		this.validateSepaPersonaFisicaEmitter.emit();
	}

	onExistsDelegatoRiscossioneChange(tipo): void {
		if (!tipo.value) {
			this.resetEstremiPersonaFisicaSepaFormEmitter.emit();
		}
	}

	sepaCountriesValidator(): ValidatorFn {
		return (form: AbstractControl) => {
		  const iban = form.value;
		  if (!iban || iban?.length < 2) {
				return null;
		  }

		  const countryCode: string = iban.substring(0, 2);
		  if (!this.sepaCountries.some((element) => element.code === countryCode)) {
				return { ibanExtraSepa: true };
		  }

		  return null;
		};
	}

	onDelegatoRiscossioneReady(event: { persona: DatiPersonaFisicaModel, isValid: boolean }){
		this.delegato = event.persona;
		this.isDelegatoValid = event.isValid;
		this.personaFisicaEmitter.emit({ persona: event.persona, isValid: event.isValid });
	}

	convertToUppercase(value: string) {
		this.sepaForm.get('iban').setValue(value.toUpperCase());
	}

	noSpacesValidator(): ValidatorFn {
		return (control: AbstractControl): { [key: string]: any } | null => {
			const hasSpaces = /\s/.test(control.value);
			return hasSpaces ? { spacesIban: true } : null;
		};
	}

}
